/* Copyright (c) 2020-present CloudIO Inc */

import React, { lazy, Suspense } from 'react';
import SimpleLoading from 'root/SimpleLoading';

const WithTailwindLazy = lazy(
  () => import(/* webpackChunkName: "tw" */ './WithTailwindLazy'),
);

export function WithTailwind({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<SimpleLoading name="WithTailwind" />}>
      <WithTailwindLazy>{children}</WithTailwindLazy>
    </Suspense>
  );
}
